var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4454 16.6872H6.55535C2.87285 16.6872 1.29785 15.1122 1.29785 11.4297V11.3322C1.29785 8.00221 2.61035 6.39721 5.55035 6.11971C5.85035 6.09721 6.13535 6.32221 6.16535 6.62971C6.19535 6.93721 5.97035 7.21471 5.65535 7.24471C3.30035 7.46221 2.42285 8.57221 2.42285 11.3397V11.4372C2.42285 14.4897 3.50285 15.5697 6.55535 15.5697H11.4454C14.4979 15.5697 15.5779 14.4897 15.5779 11.4372V11.3397C15.5779 8.55721 14.6854 7.44721 12.2854 7.24471C11.9779 7.21471 11.7454 6.94471 11.7754 6.63721C11.8054 6.32971 12.0679 6.09721 12.3829 6.12721C15.3679 6.38221 16.7029 7.99471 16.7029 11.3472V11.4447C16.7029 15.1122 15.1279 16.6872 11.4454 16.6872Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.8123C8.6925 11.8123 8.4375 11.5573 8.4375 11.2498V2.71484C8.4375 2.40734 8.6925 2.15234 9 2.15234C9.3075 2.15234 9.5625 2.40734 9.5625 2.71484V11.2498C9.5625 11.5573 9.3075 11.8123 9 11.8123Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5124 4.95008C11.3699 4.95008 11.2274 4.89758 11.1149 4.78508L8.99988 2.67008L6.88488 4.78508C6.66738 5.00258 6.30738 5.00258 6.08988 4.78508C5.87238 4.56758 5.87238 4.20758 6.08988 3.99008L8.60238 1.47758C8.81988 1.26008 9.17988 1.26008 9.39738 1.47758L11.9099 3.99008C12.1274 4.20758 12.1274 4.56758 11.9099 4.78508C11.8049 4.89758 11.6549 4.95008 11.5124 4.95008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.a30f76849efa6f7e4afffd8718c8e6a3.svg";
export { ForwardRef as ReactComponent };